import React, { useState, useEffect, useRef } from "react" ;
import axios from 'axios'
import PaypalCheckoutMain from "./PaypalCheckoutMain";

const PaypalCheckoutHSK2 = () => {
   
    return (
        <PaypalCheckoutMain
        amountTotal="21.00"
        hsk="_hsk2"
        hskNumber="2"
      />
    );
}

export default PaypalCheckoutHSK2